export type ApiLocale = 'en' | 'ja-JP, ja;q=0.9';

let apiLocale: ApiLocale = 'ja-JP, ja;q=0.9';

export const getApiLocale = (): ApiLocale => apiLocale;

export const setApiLocale = (locale: string): void => {
  apiLocale = locale === 'en' ? 'en' : 'ja-JP, ja;q=0.9';
};
